<template>
  <div class="m-0 checkboxWrapper">
    <ValidationProvider
      :rules="validation"
      v-slot="{ errors }"
      :name="name || label"
    >
      <div class="wrapper_best" :style="styles">
        <div class="custom-control custom-checkbox custom-checkbox-arrow pt-1">
          <input
            v-model="localChecked"
            :name="validationName"
            :checked="checked"
            type="checkbox"
            class="custom-control-input"
            :id="validationName"
            @input="clickCheckbox"
            required
          />
          <label
            class="custom-control-label"
            :for="validationName"
            v-html="label"
          ></label>
        </div>
        <div
          v-if="expandable"
          role="button"
          data-toggle="collapse"
          :data-target="`#${fieldId}`"
          aria-expanded="false"
          :aria-controls="fieldId"
        >
          <img
            class="down-arrow"
            src="../../assets/icons/form/down-arrow.svg"
            alt
          />
        </div>
      </div>
      <div v-if="expandable" class="collapse" :id="fieldId">
        <div class="card card-body card-body-dop" v-html="expandableText"></div>
      </div>
      <div
        class="validation-error"
        style="margin-top: 5px"
        v-if="errors.length"
      >
        <!-- <img class="error_min" src="../../assets/icons/form/error.svg" alt /> -->
        {{ errors[0] }}
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "checkbox",
  data() {
    return {
      localChecked: this.checked
    };
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Empty Link Text"
    },
    expandable: {
      required: false,
      type: Boolean,
      default: false
    },
    expandableText: {
      required: false,
      type: String,
      default: ""
    },
    checked: {
      required: false,
      type: Boolean,
      default: false
    },
    fieldId: {
      type: String,
      required: true
    },
    validation: {
      type: [String, Object],
      required: false,
      default: ""
    },
    validationName: {
      required: false,
      type: String,
      default: ""
    },
    checkOnClick: {
      required: false,
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  mounted() {
    this.$emit("component-updated", {
      checked: !!this.checked
    });
    this.$emit("input", !!this.checked);
  },
  watch: {
    localChecked(value) {
      this.$emit("component-updated", {
        checked: value
      });
      this.$emit("input", value);
    }
  },
  methods: {
    clickCheckbox(value) {
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: value.target.checked
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$medium: 800px;
.validation-error {
  // @media only screen and (max-width: $medium) {
  //   margin-left: 15px !important;
  // }
}

.checkboxWrapper {
  font-family: "Plus Jakarta Sans";
  padding: 5px;
}
.form-group {
  margin-bottom: 20px;
}
.form-field {
  margin-bottom: 20px;
}
.wrapper_input {
  position: relative;
}
.form-field__label {
  position: absolute;
  top: 50%;
  left: 10px;
  padding-left: 7px;
  padding-right: 7px;
  transition: transform 0.1s;
  pointer-events: none;
  transform-origin: 0 100%;
  transform: translateY(-50%);
  letter-spacing: 0.14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #0f2967;
}
.form-field__input {
  background: transparent !important;
  outline: 0;
  box-shadow: none;
  transition: border-color 0.15s;
  border-radius: 0px !important;
  border: 1px solid #808080 !important;
  box-sizing: border-box !important;
  padding-left: 15px !important;
  height: 48px !important;
  cursor: pointer;
  width: 100%;
  font-size: 14px;
}
.form-field__input:focus + .form-field__label,
.form-field__input.visited + .form-field__label {
  transform: translateY(-140%) scale(0.7);
}
.wrapper-i {
  cursor: pointer;
}
.wrapper_weit {
  display: flex;
  align-items: center;
}
.information-img {
  width: 18px;
}
.add-img {
  width: 30px;
  margin-right: 20px;
}
.is-invalid {
  .form-field__input {
    border-color: #ff5a5a !important;
  }
  .invalid-feedback {
    display: block;
  }
}
.wrapper_best {
  display: flex;
  position: relative;
  // @media only screen and (max-width: $medium) {
  //   margin-left: 30px;
  //   margin-right: 20px;
  // }
  .custom-control {
    padding-left: 35px;
  }

  .custom-checkbox .custom-control-label {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: var(--color);
    cursor: pointer;
  }
  .custom-checkbox .custom-control-label::before,
  .custom-checkbox .custom-control-label::after {
    left: -35px;
  }
}
.down-arrow {
  width: 16px;
  transition: all 0.3s;
  margin-left: 10px;
  margin-top: -8px;
}
[aria-expanded="true"] {
  .down-arrow {
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

.card-body-dop {
  border: none;
  padding-left: 35px;
}
.custom-radio {
  padding-left: 35px;
  margin-right: 20px;
}
.custom-control-label::after,
.custom-checkbox .custom-control-label::before {
  width: 20px;
  height: 20px;
  top: 0px;
  left: -35px;
}
.custom-checkbox-dop {
  position: absolute;
  bottom: 5px;
  right: 10px;
  .custom-control-label {
    &:after,
    &:before {
      left: -20px;
    }
  }
}
.custom-control-label::after,
.custom-checkbox .custom-control-label::before,
.custom-control-input[type="radio"] {
  background-color: transparent !important;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 0px;
  cursor: pointer;
}
.custom-checkbox .custom-control-label::before {
  background-image: var(--uncheckedCheckbox) !important;
  background-repeat: no-repeat;
  box-shadow: none !important;
  background-size: 20px;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: var(--checkedCheckbox) !important;
  background-repeat: no-repeat;
  background-size: 20px;
}
.text_min {
  font-size: 14px;
  letter-spacing: 0.14px;
  line-height: 16px;
}
</style>
